/**
 * Chain multiple handlers one by one and invoke each other with same params. Also filter nil handlers.
 *
 * @documented
 * @category Function
 * @param {Functions} handlers array of handlers
 * @example
 *
 * 		chainHandlersAsync([onClick, onChange])('dog') // => both called with 'dog' as first argument
 *
 */ const chainHandlersAsync = (handlers)=>async (...args)=>{
        for (const handler of handlers){
            if (handler) {
                // it is intended to run handlers one by one
                await handler(...args);
            }
        }
    };
export default chainHandlersAsync;
